import { ReactNode, useEffect } from "react";
import { Button, Flex, Heading, Separator } from '@radix-ui/themes';
import { Icon } from '@cloudscape-design/components';
import "./SlideOutPanel.css";

interface SlideOutPanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: string;
  side?: "left" | "right";
  showTitle?: boolean;
}

export default function SlideOutPanel({
  isOpen,
  onClose,
  children,
  width = "300px",
  side = "left",
  showTitle = true,
}: SlideOutPanelProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  return (
    <>
      <div
        className={`slide-out-overlay ${isOpen ? "active" : ""}`}
        onClick={onClose}
      />
      <div
        className={`slide-out-panel ${side} ${isOpen ? "open" : ""}`}
        style={{ width }}
      >
        <Flex align="center" py={{ initial: "2", sm: "3" }}>
          <Button
            className="slide-out-close"
            mx={{ initial: "2", sm: "3" }}
            onClick={onClose}
          >
            <Icon name="close" />
          </Button>
          {showTitle && <Heading size={{ initial: "5", sm: "6" }}>Feedback</Heading>}
        </Flex>
        <Separator size="4" />
        <div className="slide-out-content">{children}</div>
      </div>
    </>
  );
}
